<template>
  <div>name: <el-input v-model="name" placeholder=""></el-input></div>
  <div>age: <el-input v-model="age" placeholder=""></el-input></div>

  <div>
    <el-button type="primary" @click="validatorClick">Validator</el-button>
  </div>
  <div>Result:{{ result }}</div>
</template>

<script setup>
import { ref } from 'vue';

import Schema from 'async-validator';

const name = ref('');
const age = ref(0);

const result = ref();

var descriptor = {
  name: [
    {
      required: true,
      type: 'string',
      message: '不能为空',
    },
  ],
  age: [
    {
      type: 'number',
      message: '错误数据',
      validator(rule, value) {
        return parseFloat(value) !== 'NaN' && !isNaN(value);
      },
    },
    {
      message: '不能等于1',
      validator(rule, value) {
        return parseFloat(value) !== 1;
      },
    },
  ],
};

const validatorClick = async () => {
  const validator = new Schema(descriptor);

  const data = { name: name.value, age: age.value };
  console.log('data', data);

  validator.validate(data, (errors, fields) => {
    console.log('校验失败', errors, fields);
    errors.forEach((err) => {
      eval('descriptor.' + err.field).validateResult = {
        validation: false,
        message: err.message,
      };
    });

    console.log('descriptor', descriptor);
  });
};
</script>
<style scoped></style>
